export default {
  path: '/rank',
  name: 'rank',
  component: () => import(/* webpackChunkName: "learning" */ '@/views/rank/Rank.vue'),
  children: [
    {
      path: 'study-rank',
      name: 'study-rank',
      component: () => import('@/views/rank/StudyRank.vue'),
    },
    {
      path: 'pk-rank',
      name: 'pk-rank',
      component: () => import('@/views/rank/PkRank.vue'),
    },
  ],
};
